<script setup lang="ts">
</script>
<template>
  <div class="flex flex-col w-full h-full max-h-[100vh] overflow-y-auto bg-[var(--white)]">
    <RouterView />
  </div>
</template>
